import {Injectable} from "@angular/core";
import { Router } from '@angular/router';
import { Session } from "../model/session";
import { Usuario } from "../model/usuario";


@Injectable({
  providedIn: 'root'
})
export class StorageService {

  
  private localStorageService;
  private currentSession : Session = null;

  constructor(private router: Router) {
    this.localStorageService = localStorage;
    this.currentSession = this.loadSessionData();
  }

  setCurrentSession(session: Session): void {
    this.currentSession = session;
    this.localStorageService.setItem('currentUser', JSON.stringify(session));
  }

  loadSessionData(): Session{
    var sessionStr = this.localStorageService.getItem('currentUser');
    return (sessionStr) ? <Session> JSON.parse(sessionStr) : null;
  }

  getCurrentSession(): Session {
    if(this.currentSession != null){
      var now = new Date();
      var sessionDate = new Date(this.currentSession.fecha);
      var difference = (now.getTime() - sessionDate.getTime()); 
      var resultInMinutes = Math.round(difference / 60000);
      if(resultInMinutes < 180){
        return this.currentSession;
      }else{
        this.logout();
      }
    }
  }

  removeCurrentSession(): void {
    this.localStorageService.removeItem('currentUser');
    this.localStorageService.removeItem('menuActivo');
    this.currentSession = null;
  }

  getCurrentUser(): Usuario {
    var session: Session = this.getCurrentSession();
    return (session && session.ususario) ? session.ususario : null;
  };

  isAuthenticated(): boolean {
    var session: Session = this.getCurrentSession();
    return (session && session.ususario) ? true : false;
  };


  logout(): void{
    this.removeCurrentSession();
    this.router.navigate(['login']);
  }

  setMenuActivo(menuActivo : string) : void{
    this.localStorageService.setItem('menuActivo', menuActivo);
  }

  getMenuActivo(): string{
    var menuActivo = this.localStorageService.getItem('menuActivo');
    return menuActivo;
  }

}